export const sanitizeSnakeCase = (string: string) => string
    .replace(/\W/g, '')
    .replace(/(_)\1+/g, '$1')
    .replace(/^_+|_+$/g, '');
